import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full" role="navigation" aria-label="主导航">
        <div className="mx-auto max-w-[1400px] px-4 md:px-6 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="回到首页">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span className="text-lg font-bold text-foreground-950 font-heading">
              17c一起草在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              {t("home")}
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              {t("about")}
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={isMobileMenuOpen}
          >
            <i className={`ri-${isMobileMenuOpen ? "close" : "menu"}-line text-xl`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200">
            <div className="px-4 py-3 flex flex-col gap-1">
              <Link
                to="/"
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === "/"
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {t("home")}
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    location.pathname === `/category/${cat.slug}`
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === "/about"
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {t("about")}
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}